<template>
  <div>
    <vs-tabs class="bg_filled_tab_holder" v-model="tabIndex">
      <vs-tab label="Localisation" icon="event">
        <div>
          <Localisation
            :currency_id="currency_id"
            :time_format_id="time_format_id"
            :platform_timezone_id="platform_timezone_id"
            :date_format_id="date_format_id"
            :start_day_id="start_day_id"
            :weekStart="weekStart"
            :dateFormat="dateFormat"
            :timeFormat="timeFormat"
            :can_update_currency="can_update_currency"
            @saveLocalisationSettings="saveLocalisationSettings"
          />
        </div>
      </vs-tab>
      <vs-tab label="Theme" icon="perm_media">
        <div>
          <Theme
            :header="header"
            :footer="footer"
            :themeSettings="themeSettings"
            @saveThemeSetting="saveThemeSetting"
          />
        </div>
      </vs-tab>
      <vs-tab label="Modules" icon="content_copy">
        <div>
          <vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
              <vs-card class="content_mb_0 mb-0">
                <div style="border-bottom: 1px solid #dddce0" slot="header">
                  <h4 class="pb-4">Communication</h4>
                </div>
                <Communication />
              </vs-card>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-2">
              <vs-card class="content_mb_0 mb-0">
                <Tags />
              </vs-card>
            </vs-col>
            <vs-col vs-w="12" class="p-2">
              <ModuleCustomization />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import {
  getSetting,
  setSettings
} from '@/api/setting.js'
import { mapActions } from 'vuex'

import Localisation from './localisation.vue'
import Theme from './theme.vue'
import Communication from '@/views/pages/communication/settings.vue'
import Tags from '@/views/pages/tags/index.vue'
import ModuleCustomization from '@/views/pages/customsettings/index.vue'

export default {
  components: {
    Localisation,
    Theme,
    Communication,
    Tags,
    ModuleCustomization
  },
  data () {
    return {
      contact_email: [],
      currency_id: 36,
      platform_timezone_id: null,
      start_day_id: '',
      date_format_id: '',
      time_format_id: '',
      invitation_setting: false,
      header: '',
      footer: '',
      can_update_currency: true,
      weekStart: [
        {
          id: 0,
          value: 'Sunday'
        },
        {
          id: 1,
          value: 'Monday'
        }
      ],
      timeFormat: [
        {
          id: 1,
          value: '12 Hrs',
          key_val: 'hh:mm a'
        },
        {
          id: 2,
          value: '24 Hrs',
          key_val: 'hh:mm'
        }
      ],
      dateFormat: [
        {
          id: 1,
          value: 'DD/MM/YY',
          key_val: 'd/m/y'
        },
        {
          id: 2,
          value: 'DD/MM/YYYY',
          key_val: 'd/m/Y'
        },
        {
          id: 3,
          value: 'MM/DD/YY',
          key_val: 'm/d/y'
        },
        {
          id: 4,
          value: 'MM/DD/YYYY',
          key_val: 'm/d/Y'
        },
        {
          id: 5,
          value: 'YYYY/MM/DD',
          key_val: 'Y/m/d'
        },
        {
          id: 6,
          value: 'YYYY/DD/MM',
          key_val: 'Y/d/m'
        }
      ],
      themeSettings: {
        logo_url: JSON.parse(localStorage.getItem('localization')).logo,
        primary: JSON.parse(localStorage.getItem('localization')).primary_color,
        secondary: JSON.parse(localStorage.getItem('localization'))
          .secondary_color,
        heading: JSON.parse(localStorage.getItem('localization')).heading_color,
        text: JSON.parse(localStorage.getItem('localization')).text_color,
        invitation_setting: JSON.parse(localStorage.getItem('localization')).invitation_setting
      }
    }
  },
  mounted () {
    this.fetchSetting()
    console.log(this.tabIndex)
  },
  props: {
    tabIndex:{
      default: 0
    }
  },
  methods: {
    ...mapActions(['SET_LOCALIZATION']),
    saveLocalisationSettings (payload) {
      this.currency_id = payload.currency_id
      this.platform_timezone_id = payload.platform_timezone_id
      this.time_format_id = payload.time_format_id
      this.date_format_id = payload.date_format_id
      this.start_day_id = payload.start_day_id

      this.saveSettings()
    },
    changeThemeColor () {
      this.$vs.theme({
        primary: JSON.parse(localStorage.getItem('localization')).primary_color,
        secondary: JSON.parse(localStorage.getItem('localization')).secondary_color,
        heading: JSON.parse(localStorage.getItem('localization')).heading_color,
        text: JSON.parse(localStorage.getItem('localization')).text_color
      })
    },
    saveThemeSetting (payload) {
      console.log(payload)
      this.header = payload.header
      this.footer = payload.footer
      this.themeSettings.primary = payload.primary_color
      this.themeSettings.secondary = payload.secondary_color
      this.themeSettings.heading = payload.heading_color
      this.themeSettings.text = payload.text_color
      this.themeSettings.logo_url = payload.logo
      this.invitation_setting = payload.invitation_setting

      this.saveSettings()
    },
    saveSettings () {
      this.$validator.validateAll('GeneralSettings').then((valid) => {
        if (valid) {
          const payload = {
            currency_id: this.currency_id,
            platform_timezone_id: this.platform_timezone_id,
            contact_email: this.contact_email,
            invitation_setting: this.invitation_setting,
            header: this.header,
            footer: this.footer,
            start_day_id: this.start_day_id,
            date_format_id: this.date_format_id,
            time_format_id: this.time_format_id,
            primary_color: this.themeSettings.primary,
            secondary_color: this.themeSettings.secondary,
            heading_color: this.themeSettings.heading,
            text_color: this.themeSettings.text,
            logo: this.themeSettings.logo_url,
            date_format: this.dateFormat[this.date_format_id - 1].value,
            back_date_format: this.dateFormat[this.date_format_id - 1].key_val,
            time_format: this.timeFormat[this.time_format_id - 1].key_val
          }

          this.updateSettings(payload)
        }
      })
    },
    async updateSettings (payload) {
      const customer_id = localStorage.getItem('customer_id')

      try {
        const data = await setSettings(customer_id, payload)
        localStorage.setItem('localization', JSON.stringify(data.data.data[0]))
        this.SET_LOCALIZATION(data.data.data[0])
        localStorage.date_format =
          this.dateFormat[payload.date_format_id - 1].key_val
        localStorage.time = this.timeFormat[payload.time_format_id - 1].id
        localStorage.currency_id = payload.currency_id
        localStorage.start_day_id = payload.start_day_id

        this.changeThemeColor()
        this.changeLogo = false

        this.showSuccessMessage(
          'Success',
          'Settings Updated Successfully',
          'success'
        )
      } catch (error) {
        console.warn(error)
      }
    },
    async fetchSetting () {
      const customer_id = localStorage.getItem('customer_id')

      const { data } = await getSetting(customer_id)
      if (data.data[0] !== null) {
        this.contact_email = data.data[0].contact_email
        this.currency_id = data.data[0].currency_id
        this.platform_timezone_id = data.data[0].platform_timezone_id
        this.start_day_id = data.data[0].start_day_id
        this.date_format_id = data.data[0].date_format_id
        this.time_format_id = data.data[0].time_format_id
        this.header = data.data[0].header
        this.footer = data.data[0].footer
        this.invitation_setting = data.data[0].invitation_setting
        this.can_update_currency = data.data[0].can_update_currency
      }
      localStorage.setItem('localization', JSON.stringify(data.data.data[0]))
      this.SET_LOCALIZATION(data.data.data[0])
    }
  }
}
</script>
